import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { TranslationKey } from '@tolgee/ngx';
import { combineLatest } from 'rxjs';
import { CLEARPATH_STRING, CLIMATEVIEW_STRING } from '../../app.constants';
import { injectServiceProviderName } from './inject-service-provider-name';
import { injectTranslate } from './inject-translate';
import { injectUntilDestroyed } from './inject-until-destroyed';

export const injectSetPageTitle = (tabTitle?: TranslationKey): void => {
  const serviceProvider = injectServiceProviderName();
  const serviceProvider$ = toObservable(serviceProvider);
  const titleService = inject(Title);
  const translate = injectTranslate();
  const untilDestroyed = injectUntilDestroyed();

  if (!tabTitle) {
    serviceProvider$.pipe(untilDestroyed()).subscribe((serviceProvider) => {
      const baseTitle = serviceProvider === 'ICLEI USA' ? CLEARPATH_STRING : CLIMATEVIEW_STRING;
      titleService.setTitle(baseTitle);
    });
  } else {
    const tabTitle$ = translate.toObservable(tabTitle);
    combineLatest({ serviceProvider: serviceProvider$, translatedTabTitle: tabTitle$ })
      .pipe(untilDestroyed())
      .subscribe(({ serviceProvider, translatedTabTitle }) => {
        const baseTitle = serviceProvider === 'ICLEI USA' ? CLEARPATH_STRING : CLIMATEVIEW_STRING;
        titleService.setTitle(`${translatedTabTitle} | ${baseTitle}`);
      });
  }
};
